import apiClient from "./client";

export const notificationApi = {
  getNotifications: async () => {
    const response = await apiClient.get("/notifications");
    return response.data;
  },

  markRead: async (notificationId) => {
    const response = await apiClient.put(
      `/notifications/${notificationId}/read`,
    );
    return response.data;
  },

  markAllRead: async () => {
    const response = await apiClient.put("/notifications/read-all");
    return response.data;
  },
};
